<div class="form-group">
    <label *ngIf="title">{{title}} {{control | controlRequiredText}}
    </label>

    <div [class.dropdown-purple-20]="style === 'purple'" class="dropdown dropdown-filter dropdown-input-filter"
        [id]="id + '-dp'">
        <button class="btn dropdown-toggle dropdown-toggle-no-arrow" type="button" [id]="id" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            {{enabledSelectedText === true ? (selectedText || placeholder) : placeholder }}
        </button>
        <div class="dropdown-menu dropdown-menu-filter" aria-labelledby="dropdownBtnStatus">

            <div class="mgn-bottom-10" *ngIf="enabledFilter">
                <label [for]="id + '-search'" class="accesibleHidden">{{placeholderSearch}}</label>
                <input type="text" class="form-control filter-input" [id]="id + '-search'"
                    [placeholder]="placeholderSearch" />
            </div>

            <div class="checkbox-group">
                <div *ngFor="let s of dataSelectLabel; let i = index"  >

                    <div class="wrap-checkbox">
                        <label class="radio-label" [for]="id + i">
                            <input (click)="onUncheckRadio(dataSelectLabel[i].id)" type="radio" [id]="id + i"
                                [name]="'radio-group-' + id" [value]="dataSelectLabel[i].id" [formControl]="control" />
                            <span class="radiomark"></span>
                            {{dataSelectLabel[i].text}}
                        </label>
                    </div>
                </div>

                <div class="no-result-ctn d-none ">
                    No se encontraron resultados
                </div>
            </div>
        </div>
    </div>
    <small *ngIf="messageFooter" class="form-text text-muted">{{messageFooter}}
        <a class="btn-link" *ngIf="messageFooterAction" (click)="onClickActionFooter($event)" role="button"
            [title]="messageFooterAction">{{messageFooterAction}}</a>
    </small>


</div>